angular.module('manufacturing')
    .component('manufacturingDashboardDataScope', {
        bindings: {
            translationKey: '@',
            range: '<?'
        },
        template: '<span class="manufacturing-dashboard-data-scope" ng-if="$ctrl.values.start && $ctrl.values.end" tabindex="0" uib-tooltip="{{$ctrl.translationKey | translate:$ctrl.values}}" tooltip-append-to-body="true">{{$ctrl.values.start}}–{{$ctrl.values.end}}</span>',
        controller: function () {
            this.$onChanges = () => {
                const hasRange = this.range && this.range.start && this.range.end
                this.values = hasRange ? {start: moment(this.range.start).format('DD.MM.YYYY'), end: moment(this.range.end).format('DD.MM.YYYY')} : {}
            }
        }
    })
    .factory('ManufacturingDashboardView', function () {
        const statuses = ['PENDING', 'CONFIRMED', 'IN_PROGRESS']
        const buildTimeline = (source, stacked) => (source || []).map(series => {
            const timelineLocations = (series.locations || []).map((location, index) => angular.extend({}, location, {colorIndex: index % 8}))
            const locationsById = {}
            const days = series.days || []
            timelineLocations.forEach(location => locationsById[location.id] = location)
            const dayTotals = days.map(day => (day.quantities || []).reduce((total, quantity) => total + (Number(quantity.quantity) || 0), 0))
            const values = stacked ? dayTotals : days.reduce((result, day) => result.concat((day.quantities || []).map(quantity => Number(quantity.quantity) || 0)), [])
            const max = Math.max.apply(null, values) || 1
            return angular.extend({}, series, {
                locations: timelineLocations,
                days: days.map((day, index) => {
                    const total = dayTotals[index]
                    const quantities = (day.quantities || []).map(quantity => {
                        const value = Number(quantity.quantity) || 0
                        return angular.extend({}, quantity, {location: locationsById[quantity.locationId], level: value ? Math.max(1, Math.ceil(value / max * 20)) : 0, share: total ? value / total * 100 : 0})
                    })
                    return angular.extend({}, day, {
                        total: total,
                        height: total ? Math.max(5, total / max * 100) : 0,
                        showLabel: index === days.length - 1 || (index % 5 === 0 && days.length - 1 - index > 2),
                        quantities: stacked ? quantities.filter(quantity => Number(quantity.quantity) > 0) : quantities
                    })
                })
            })
        })

        return {
            build: data => {
                const locations = (data && data.locations) || []
                const today = moment().format('YYYY-MM-DD')
                return {
                    backlogLocations: locations.map(location => ({
                        id: location.id,
                        name: location.name,
                        statuses: statuses.map(status => ({status: status, count: (location.statusCounts && location.statusCounts[status]) || 0, orderedQuantities: (location.orderedQuantities && location.orderedQuantities[status]) || []}))
                    })).filter(location => location.statuses.some(status => status.count > 0)),
                    nodes: (data && data.nodes) || [],
                    orderTimeline: buildTimeline(data && data.orderTimeline, true),
                    timeline: buildTimeline(data && data.timeline, false),
                    ranges: (data && data.ranges) || {},
                    deliveryComparison: ((data && data.deliveryComparison) || []).map(period => angular.extend({}, period, {
                        days: (period.days || []).map(day => {
                            const labels = (day.label || '').match(/^(\S+)\s+\((.+)\)$/)
                            return angular.extend({}, day, {
                                dateLabel: labels ? labels[1] : day.label,
                                weekdayLabel: labels ? labels[2] : null,
                                isToday: day.date === today,
                                quantities: day.quantities || []
                            })
                        })
                    }))
                }
            }
        }
    })
    .component('manufacturingOrderDeliveryComparisonDashboard', {
        bindings: {
            periods: '<',
            location: '<',
            locationName: '<',
            range: '<'
        },
        templateUrl: 'app/manufacturing/dashboard-comparison.html',
        controller: function () {
            this.orderFilters = period => {
                const today = moment().startOf('day')
                const recent = period.period === 'RECENT'
                return {
                    startDate: (recent ? today.clone().subtract(6, 'days') : today.clone().add(1, 'day')).format('YYYY-MM-DD'),
                    endDate: (recent ? today : today.clone().add(7, 'days')).format('YYYY-MM-DD'),
                    location: this.location || null,
                    page: null
                }
            }

            this.dayOrderFilters = day => ({startDate: day.date, endDate: day.date, location: this.location || null, page: null})
        }
    })
    .component('manufacturingOrderDashboardWidget', {
        templateUrl: 'app/manufacturing/dashboard-widget.html',
        controller: function ($scope, ManufacturingOrder, ManufacturingDashboardView, Principal) {
            const defaultPeriods = () => {
                const today = moment()
                return {
                    backlog: {start: null, end: null},
                    nodes: {start: today.clone().subtract(29, 'days').format('YYYY-MM-DD'), end: today.format('YYYY-MM-DD')},
                    orderTimeline: {start: today.clone().subtract(29, 'days').format('YYYY-MM-DD'), end: today.clone().add(7, 'days').format('YYYY-MM-DD')},
                    timeline: {start: today.clone().subtract(29, 'days').format('YYYY-MM-DD'), end: today.format('YYYY-MM-DD')}
                }
            }
            this.data = null
            this.view = null
            this.location = null
            this.selectedLocation = null
            this.periods = defaultPeriods()
            this.loading = false

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
                this.unwatchOrderUpdated = $scope.$on('manufacturing-order.updated', () => this.loadStatistics())
                this.unwatchOrderDeleted = $scope.$on('manufacturing-order.deleted', () => this.loadStatistics())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) this.unwatchAuthenticationChanged()
                if (angular.isFunction(this.unwatchOrderUpdated)) this.unwatchOrderUpdated()
                if (angular.isFunction(this.unwatchOrderDeleted)) this.unwatchOrderDeleted()
            }

            this.refreshPermissionsAndData = () => Principal.hasAuthority('ROLE_MANUFACTURING_ORDER_MANAGEMENT')
                .then(hasAccess => {
                    this.hasAccess = hasAccess
                    if (hasAccess) {
                        return this.loadStatistics()
                    }
                    this.data = null
                    this.view = null
                })

            this.loadStatistics = () => {
                if (!this.hasAccess) return
                this.loading = true
                const params = {
                    realisationStartDate: this.periods.nodes.start,
                    realisationEndDate: this.periods.nodes.end,
                    realisationTimelineStartDate: this.periods.timeline.start,
                    realisationTimelineEndDate: this.periods.timeline.end,
                    orderTimelineStartDate: this.periods.orderTimeline.start,
                    orderTimelineEndDate: this.periods.orderTimeline.end
                }
                if (this.periods.backlog.start && this.periods.backlog.end) {
                    params.startDate = this.periods.backlog.start
                    params.endDate = this.periods.backlog.end
                }
                if (this.location) params.location = this.location
                return ManufacturingOrder.dashboard(params).$promise
                    .then(data => {
                        this.data = data
                        this.view = ManufacturingDashboardView.build(data)
                    })
                    .catch(() => {
                        this.data = null
                        this.view = null
                    })
                    .finally(() => this.loading = false)
            }

            this.onLocationChanged = location => {
                this.selectedLocation = location || null
                this.location = location ? location.id : null
                return this.loadStatistics()
            }

            this.onPeriodChanged = (type, start, end) => {
                this.periods[type] = start && end ? {start: start, end: end} : defaultPeriods()[type]
                return this.loadStatistics()
            }

            this.orderFilters = (status, location) => ({status: status, location: location || this.location || null, startDate: this.periods.backlog.start, endDate: this.periods.backlog.end, page: null})
            this.timelineOrderFilters = (day, location) => ({
                startDate: day.date,
                endDate: day.date,
                location: location || this.location || null,
                status: ['PENDING', 'CONFIRMED', 'IN_PROGRESS', 'COMPLETED'],
                page: null
            })
            this.orderTimelineFilters = day => ({
                startDate: day.date,
                endDate: day.date,
                location: this.location || null,
                status: ['PENDING', 'CONFIRMED', 'IN_PROGRESS', 'COMPLETED'],
                page: null
            })
            this.showTimelineHelp = (type, day, series) => this.activeTimelineHelp = {
                type: type,
                date: day.label,
                total: day.total,
                quantities: (day.quantities || []).filter(quantity => Number(quantity.quantity) > 0),
                unit: series.unit
            }
        }
    })
